import {
  GET_LOOKUP_ACTION_OK,
  GET_LOOKUP_ACTION_ERR,
} from "./action-lookup.action";

const InitState = {
  error: null,
  content: null,
};

export default function LookupActionReducer(state = InitState, action) {
  switch (action.type) {
    case GET_LOOKUP_ACTION_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_LOOKUP_ACTION_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
